import { useCallback } from 'react';
import MunicipalPortalAAppService from 'application/platform/municipal-portal-service';
import { downloadFile } from 'utils/download-file';
import { useContratoDetailsDispatch } from './contrato-details-context';
import { ACTION_TYPES } from './contrato-details-reducer';

export const useContratoDetailsController = () => {
  const dispatch = useContratoDetailsDispatch();

  const loadContratoDetails = useCallback(async (id: number) => {
    try {
      dispatch({ type: ACTION_TYPES.setLoading, payload: true });
      dispatch({ type: ACTION_TYPES.setError, payload: null });

      const response = await MunicipalPortalAAppService.getContrato(id);

      dispatch({ type: ACTION_TYPES.setContratoDetails, payload: response });
    } catch (error) {
      console.error('Error loading contrato details:', error);
      dispatch({ type: ACTION_TYPES.setError, payload: 'Erro ao carregar detalhes do contrato' });
      dispatch({ type: ACTION_TYPES.setContratoDetails, payload: null });
    } finally {
      dispatch({ type: ACTION_TYPES.setLoading, payload: false });
    }
  }, [dispatch]);

  const clearContratoDetails = useCallback(() => {
    dispatch({ type: ACTION_TYPES.setContratoDetails, payload: null });
    dispatch({ type: ACTION_TYPES.setError, payload: null });
  }, [dispatch]);

  const exportContratoDetail = useCallback(async (id: number, format: string) => {
    const file = await MunicipalPortalAAppService.exportContratoDetail(id, format);
    downloadFile(file);
  }, []);

  return {
    loadContratoDetails,
    clearContratoDetails,
    exportContratoDetail,
  };
};
